import {hasFreeTrial, isPartiallyPaid} from '../../../../../domain/utils/total.util';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {Totals, TotalsDataHook} from '../../../../../common/components/Totals/Totals';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {classes} from '../TotalsSection.st.css';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../common/constants';

export const PaymentBreakdown = () => {
  const {cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const localeKeys = useLocaleKeys();
  const shouldSupportFreeTrial = hasFreeTrial(cartSummary!);
  const isCheckoutPartiallyPaid = isPartiallyPaid(cartSummary!);
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  if (!isCheckoutPartiallyPaid && !shouldSupportFreeTrial) {
    return;
  }

  return (
    <Totals.TotalsSection
      dataHook={TotalsSectionDataHooks.PaymentBreakdownSection}
      shouldShowUpperDivider={checkoutUIRevampOrderSummary}>
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.PayNowRow}
        title={() => (
          <Text className={classes.totalRowText} data-hook={TotalsDataHook.TotalsRowTitle}>
            {localeKeys.checkout.orderSummary.amountDueNow.label()}
          </Text>
        )}
        value={() =>
          isCartSummaryUpdating ? (
            <TotalUpdateSkeleton />
          ) : (
            <Text className={classes.totalRowText}>{cartSummary!.paymentSummary.payNow.formattedAmount}</Text>
          )
        }
      />
      {shouldSupportFreeTrial && (
        <Totals.TotalsRow
          dataHook={TotalsSectionDataHooks.PayAfterTrialRow}
          title={() => (
            <Text data-hook={TotalsDataHook.TotalsRowTitle}>
              {localeKeys.checkout.pricingPlans.afterFreeTrial.label()}
            </Text>
          )}
          value={() =>
            isCartSummaryUpdating ? (
              <TotalUpdateSkeleton />
            ) : (
              <Text className={classes.totalRowText}>
                {cartSummary!.paymentSummary.payAfterFreeTrial?.formattedAmount}
              </Text>
            )
          }
        />
      )}
      {isCheckoutPartiallyPaid && (
        <Totals.TotalsRow
          dataHook={TotalsSectionDataHooks.PayLaterRow}
          title={() => (
            <Text data-hook={TotalsDataHook.TotalsRowTitle}>
              {localeKeys.checkout.orderSummary.amountDueLater.label()}
            </Text>
          )}
          value={() =>
            isCartSummaryUpdating ? (
              <TotalUpdateSkeleton />
            ) : (
              <Text className={classes.totalRowText}>{cartSummary!.paymentSummary.payLater?.formattedAmount}</Text>
            )
          }
        />
      )}
    </Totals.TotalsSection>
  );
};
